<template lang="pug">
.notes-list.ui.segments(v-show='filtered_groups.length')
  .ui.segment.item(v-for='group in filtered_groups', :class='{pinned: group.pinned}')
    .no(
      v-if='showLabel && group.no',
      @click='label_click(group)',
      v-text='group.no'
    )

    .pinned-icon(v-if='group.pinned')
      i.icon.pin

    .notes(@click='open(group)')
      .item(v-for='item in group.notes', :class='{semitrans: item.state}')
        .time {{$formatters.date.to_date_short(item.time_modified)}}
        .tags(v-if='item.tags && item.tags.length')
          .tag(v-for='tag in item.tags', :style='{background:tag_color(tag)}') {{tag}}
        pre.content(:class='{checked:item.state}', v-text='note_format(item)')
        .operator(v-if='item._modifier') {{' - ' + item._modifier}}

</template>

<script>
import tinycolor from 'tinycolor2'

export default {
  name: 'notes-list',
  props: {
    groups: Array,
    notes: Array,
    filter: String,
    showLabel: { type: Boolean, default: true },
  },
  computed: {
    filtered_groups() {
      const groups = this.groups ? this.groups : [{ notes: this.notes || [] }]
      return groups
        .map(group => {
          const notes = this.filtered_notes(group.notes || [])
          if (!notes.length)
            return undefined
          return {
            ...group,
            notes,
          }
        })
        .filter(i => i)
    },
  },
  methods: {
    open(group) {
      this.$emit('open', group)
    },
    note_format(item) {
      const note = item.note || ''
      return note.trim()
    },
    label_click(group) {
      this.$emit('label-clicked', group)
    },
    tag_color(text) {
      const hash = text.split('').reduce((a, b) => { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0)
      // console.log('HASH', text, hash, hash % 360)
      return tinycolor({ h: hash % 360, s: 0.36, l: 0.51 })
    },
    filtered_notes(items) {
      if (this.filter)
        return items.filter(i => i.tags && i.tags.includes(this.filter))
      return items
    },
  },
}
</script>



// WEBPACK FOOTER //
// NotesList.vue?c95599ae